import Queues from './Queues/Queues';
export default Queues;